import { render, staticRenderFns } from "./CountryOverviewDetailsCustomerTable.vue?vue&type=template&id=2bbe9e78&"
import script from "./CountryOverviewDetailsCustomerTable.vue?vue&type=script&lang=js&"
export * from "./CountryOverviewDetailsCustomerTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports